import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function AdminDisputes() {
  const [list, setList] = useState([]);
  const [active, setActive] = useState(null);
  const [resolution, setResolution] = useState("refund_buyer");
  const [notes, setNotes] = useState("");

  const refresh = () => api.get("/disputes").then(r => setList(r.data));
  useEffect(() => { refresh(); }, []);

  const resolve = async () => {
    await api.post(`/disputes/${active.id}/resolve`, { resolution, admin_notes: notes });
    toast.success("Tvist løst");
    setActive(null);
    setNotes("");
    refresh();
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Tvister</h1>
      <Card>
        <CardHeader><CardTitle>Alle tvister ({list.length})</CardTitle></CardHeader>
        <CardContent>
          {list.length === 0 ? <p className="text-sm text-muted-foreground text-center py-6">Ingen tvister</p> : (
            <div className="space-y-3">
              {list.map(d => (
                <div key={d.id} className="p-4 rounded-lg border border-border">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div>
                      <p className="font-semibold">{d.reason}</p>
                      <p className="text-xs text-muted-foreground mt-0.5">{d.initiator_name} → {d.driver_name} · Job #{d.job_id.slice(0,8)}</p>
                      {d.description && <p className="text-sm text-muted-foreground mt-2">{d.description}</p>}
                    </div>
                    <div className="flex items-center gap-2">
                      <Badge variant={d.status === "pending" ? "outline" : "secondary"}>{d.status}</Badge>
                      <span className="font-semibold">{d.amount} kr.</span>
                      {d.status === "pending" && (
                        <Button size="sm" onClick={() => setActive(d)}>Løs</Button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Løs tvist</DialogTitle></DialogHeader>
          <Select value={resolution} onValueChange={setResolution}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="refund_buyer">Refunder kunde (100%)</SelectItem>
              <SelectItem value="payout_driver">Udbetal til chauffør</SelectItem>
              <SelectItem value="split">Split 50/50</SelectItem>
            </SelectContent>
          </Select>
          <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Admin noter" rows={3} />
          <DialogFooter>
            <Button variant="outline" onClick={() => setActive(null)}>Annuller</Button>
            <Button onClick={resolve}>Bekræft</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
